export const handleIsAllNotificationReaded = ({ prevState }) => {
  return prevState.notifications.every(
    (notification) => !notification.isUnread
  );
};
